// Animation utility functions
export const highlightElement = (
  element: HTMLElement | null,
  color: string,
  duration = 1000
) => {
  if (!element) return

  // Store original background
  const originalBackground = element.style.backgroundColor

  // Create keyframes for smooth transition
  element.style.transition = `background-color 0.3s ease-in-out`
  element.style.backgroundColor = `${color}40` // 40% opacity

  setTimeout(() => {
    element.style.backgroundColor = originalBackground

    // Clean up transition after animation
    setTimeout(() => {
      element.style.transition = ''
    }, 300)
  }, duration - 300)
}
